// implement toast from react-hot-toast
import React from 'react';
import { createRoot } from 'react-dom/client';
import toast, { Toaster } from 'react-hot-toast';


export const renderToast = () => {
    const containerId = 'mrca-toast-container';
    let root = document.getElementById(containerId);
    if (!root) {
        root = document.createElement('div');
        root.id = containerId;
        document.body.appendChild(root);
    }
    createRoot(root).render(<Toast />);
}

const Toast = () => {
    const currentPageUrl = window.location.href;

    const hasToast = currentPageUrl.includes('toast');

    const handleToastInitialization = () => {
        const val = currentPageUrl.split('toast=')[1];
        const decodedVal = decodeURIComponent(val);

        toast.error(decodedVal);

        // TODO - remove the toast param from the url
        window.history.replaceState({}, '', currentPageUrl.split('?')[0]);
    }

    if (hasToast) {
        handleToastInitialization();
    }
    return (
        <Toaster
            position='top-right'
            reverseOrder={false}
            toastOptions={{
                className: 'toast',
                duration: 5000,
                style: {
                    borderRadius: '10px',
                    background: 'red',
                    color: '#fff',
                },
            }}
            
        />
    );

}

